/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import { Chip } from '@mui/material';

const backgroundColours = {
	HIGH: 'rgba(254, 220, 223)',
	MEDIUM: 'rgba(254, 237, 211)',
	LOW: 'rgba(216, 246, 229)',
	'': 'rgba(240, 240, 240)',
};

const colours = {
	HIGH: 'rgba(251, 66, 80)',
	MEDIUM: 'rgba(252, 157, 19)',
	LOW: 'rgba(63, 205, 104)',
	'': 'rgba(100, 100, 100)',
};

export const PriorityChip = ({ priority }) => {
	const priorityUpper = priority?.toUpperCase() || '';
	const backgroundColor = backgroundColours[priorityUpper];
	const color = colours[priorityUpper];

	const style = useMemo(
		() => ({
			borderRadius: '8px',
			backgroundColor,
			color,
			fontWeight: 'bold',
		}),
		[color, backgroundColor],
	);

	const displayLabel = priority || '';

	return <Chip style={style} label={displayLabel} />;
};
